import { gql } from "generated-graphql";

gql(`
  fragment ProcessedManifestRow on ProcessedManifest {
    id
    epaId
    manifestTrackingNumber
    vendor
    shippedDate
    wasteLineCount
    unresolvedDiscrepancyCount
    pendingDiscrepancyCount
    discrepancyTally {
      complianceTotal
      missingEManifest
      epaCorrection
      fieldTotal
      fieldUnresolved
      fieldPending
    }
    vendor
    isEManifest
    isCertified
    eManifestCertifiedDate
    eManifestCreatedDate
    eManifestDaysInTransit
    daysSinceShipment
    eManifestComplianceEscalation
    reportedWasteGeneratorStatus
    isUniformHazardousManifest
    receivedDate
    isRegulatedEManifest
    desFacilityName
    desFacilityId
    desFacLocationStreet1
    desFacLocationCity
    desFacLocationState
    desFacLocationZip
    transporterContactedAt
    transporterContactedBy
    availableSources
    primarySource
    exceptionReportSubmission {
      id
      title
      status
      submittedAt
      updatedAt
    }
    facility {
      id
      name
      streetAddress1
      city
      state
      zip
    }
    vendorManifest {
      id
      manifestTrackingNumber
      shippedDate
      vendorSource
      desFacilityName
      desFacilityId
      desFacLocationStreet1
      desFacLocationCity
      desFacLocationState
      desFacLocationZip

      originalManifestTrackingNumber
      originalShippedDate
      originalVendorSource
      originalDesFacilityName

      manuallyEdited
    }
    wasteTransporters {
      transporterLineNumber
      transporterName
      transporterId
      daysInPossession
      vendorAddressLine1
      vendorAddressLine2
      vendorCity
      vendorState
      vendorZip
    }
    sourceDocument {
      id
      title
      documentType
      fileExtension
      storageLink
      sizeMegabytes
      createdAt
      extractionStatus
      documentMetadata {
        needsReview
      }
    }
    documentManifestId
  }
`);

export const PROCESSED_MANIFEST_DOCUMENTS_QUERY = gql(`
  query ProcessedManifestDocuments($search: String) {
    processedManifests(search: $search, page: 0, pageSize: 1) {
      items {
        id
        manifestPdf {
          id
          title
          fileExtension
          storageLink
          documentType
          sizeMegabytes
          createdAt
          extractionStatus
        }
        documents {
          id
          document {
            id
            title
            fileExtension
            documentType
            storageLink
            createdAt
            sizeMegabytes
            extractionStatus
          }
        }
        exceptionReportSubmission {
          id
          title
          documents {
            id
            type
            document {
              id
              title
              fileExtension
              documentType
              storageLink
            }
          }
        }
      }
    }
  }
`);

export const PROCESSED_MANIFESTS_QUERY = gql(`
  query ProcessedManifests($search: String, $page: Int, $pageSize: Int, $sort: [SortModel!]) {
    processedManifests(search: $search, page: $page, pageSize: $pageSize, sort: $sort) {
      items {
        ...ProcessedManifestRow
      }
      count
    }
  }
`);

// Drives the drawer's client-side validation indicators (item 5): fields with
// an Unresolved/Pending discrepancy get a warning icon. No new backend field.
export const MANIFEST_DISCREPANCIES_QUERY = gql(`
  query ManifestDiscrepancies($processedManifestId: ID!) {
    manifestDiscrepancies(processedManifestId: $processedManifestId) {
      id
      field
      status
      kind
      severity
      wasteLineUnifiedId
      eManifestValue
      vendorValue
      manifestDocumentValue
      escalation
    }
  }
`);

export const DELETE_VENDOR_MANIFEST_AND_LINE_ITEMS_MUTATION = gql(`
  mutation DeleteVendorManifestAndLineItems($id: ID!) {
    deleteVendorManifestAndLineItems(id: $id)
  }
`);

export const REVERT_VENDOR_MANIFEST_AND_LINE_ITEMS_MUTATION = gql(`
  mutation RevertVendorManifestAndLineItems($id: ID!) {
    revertVendorManifestAndLineItems(id: $id) {
      originalProcessedManifest {
        id
        manifestTrackingNumber
        shippedDate
        vendor
        desFacilityName
        vendorManifest {
          manifestTrackingNumber
          shippedDate
          vendorSource
          desFacilityName
          manuallyEdited
        }
      }
      newProcessedManifest {
        id
        manifestTrackingNumber
        shippedDate
        vendor
        desFacilityName
        vendorManifest {
          manifestTrackingNumber
          shippedDate
          vendorSource
          desFacilityName
          manuallyEdited
        }
      }
    }
  }
`);

export const DELETE_DOCUMENT_MANIFEST = gql(`
  mutation DeleteDocumentManifest($wasteManifestId: ID!) {
    deleteDocumentManifest(wasteManifestId: $wasteManifestId)
  }
`);

export const ATTACH_DOCUMENT_TO_MANIFEST = gql(`
  mutation AttachDocumentToManifest($processedManifestId: ID!, $documentId: ID!) {
    attachDocumentToManifest(processedManifestId: $processedManifestId, documentId: $documentId) {
      id
      document {
        id
        title
        fileExtension
        documentType
        storageLink
        createdAt
      }
    }
  }
`);

export const DETACH_DOCUMENT_FROM_MANIFEST = gql(`
  mutation DetachDocumentFromManifest($processedManifestDocumentId: ID!) {
    detachDocumentFromManifest(processedManifestDocumentId: $processedManifestDocumentId)
  }
`);

export const MARK_TRANSPORTER_CONTACTED = gql(`
  mutation MarkTransporterContacted($processedManifestId: ID!, $contactedBy: String!, $contactedAt: DateTime!) {
    markTransporterContacted(processedManifestId: $processedManifestId, contactedBy: $contactedBy, contactedAt: $contactedAt) {
      id
      transporterContactedAt
      transporterContactedBy
    }
  }
`);

export const CREATE_EXCEPTION_REPORT_SUBMISSION = gql(`
  mutation CreateExceptionReportSubmission($processedManifestId: ID!) {
    createExceptionReportSubmission(processedManifestId: $processedManifestId) {
      id
      title
      status
    }
  }
`);
